"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _colors = require("HubStyleTokens/colors");

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _connectedUpgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/connectedUpgradeDataPropsInterface");

var _submitPql = require("ui-addon-upgrades/_core/pql/submitPql");

var _RepTypes = require("ui-addon-upgrades/_core/common/constants/RepTypes");

var Tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var TRUSTED_DOMAINS = ['https://www.hubspot.com', 'https://hubspot.com', 'https://app.hubspot.com', 'https://meetings.hubspot.com'];
var sourceSuffix = '-iscfallback';
var Modal = (0, _styledComponents.default)(function (props) {
  // eslint-disable-next-line no-unused-vars
  var hideBackground = props.hideBackground,
      rest = (0, _objectWithoutProperties2.default)(props, ["hideBackground"]);
  return _react.default.createElement(_UIModal.default, rest);
}).withConfig({
  displayName: "MeetingModal__Modal",
  componentId: "n2d2qx-0"
})(["&&&{background-color:", ";}"], function (props) {
  return props.hideBackground ? 'transparent' : undefined;
});

var MeetingModal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(MeetingModal, _React$Component);

  function MeetingModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MeetingModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MeetingModal).call(this, props));
    _this.handleMessages = _this.handleMessages.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(MeetingModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('message', this.handleMessages);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handleMessages);
    }
  }, {
    key: "handleMessages",
    value: function handleMessages(e) {
      var isKnownOrigin = TRUSTED_DOMAINS.includes(e.origin);
      var upgradeData = this.props.upgradeData;
      var hasAssignedSalesRep = Boolean(upgradeData.repInfo && upgradeData.repInfo.link && upgradeData.repInfo.type === _RepTypes.MARKETING_SALES);
      if (!isKnownOrigin) return;

      if (e.data.meetingBookSucceeded) {
        // Don't fire PQL if user has a MARKETING_SALES rep -- should've already been fired
        if (!hasAssignedSalesRep) {
          (0, _submitPql.submitPql)(Object.assign({}, upgradeData, {
            source: "" + upgradeData.source + sourceSuffix
          }));
        }

        Tracker.track('communicationMethodsInteraction', Object.assign({
          action: 'meeting booked successfully',
          meetingLink: this.props.meetingLink
        }, upgradeData));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onReject = _this$props.onReject,
          onCancel = _this$props.onCancel,
          _contextual = _this$props._contextual,
          meetingLink = _this$props.meetingLink,
          hideBackground = _this$props.hideBackground;
      return _react.default.createElement(Modal, {
        "data-test-id": "meeting-modal",
        use: "conversational",
        size: "auto",
        _contextual: _contextual,
        width: 900,
        hideBackground: hideBackground
      }, _react.default.createElement(_UIDialogHeader.default, {
        style: {
          backgroundColor: _colors.GYPSUM
        }
      }, _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: function onClick() {
          onReject();
          onCancel();
        },
        color: _colors.EERIE
      })), _react.default.createElement("div", {
        className: "private-upgrades-meeting-modal"
      }, _react.default.createElement("iframe", {
        id: "meetingModal",
        "data-test-id": "tts-modal",
        title: "Schedule a time to chat",
        width: "900",
        height: "800",
        frameBorder: "0",
        scrolling: "no",
        marginHeight: "0",
        marginWidth: "0",
        src: meetingLink
      })));
    }
  }]);
  return MeetingModal;
}(_react.default.Component);

MeetingModal.propTypes = Object.assign({}, _connectedUpgradeDataPropsInterface.connectedUpgradeDataPropsInterface, {
  meetingLink: _propTypes.default.string,
  onReject: _propTypes.default.func,
  hideBackground: _propTypes.default.bool
});
MeetingModal.defaultProps = {
  meetingLink: null,
  onCancel: function onCancel() {},
  onReject: function onReject() {},
  hideBackground: false // The onCancel default prop can be removed once the communicationMethod
  // components are removed.

};
var _default = MeetingModal;
exports.default = _default;
module.exports = exports.default;